import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { BranchAvatarModule } from '@portal-core/branches/components/branch-avatar/branch-avatar.module';
import { BuildAvatarModule } from '@portal-core/builds/components/build-avatar/build-avatar.module';
import { DestinationAvatarModule } from '@portal-core/destinations/components/destination-avatar/destination-avatar.module';
import { ConfirmDialogModule } from '@portal-core/general/components/confirm-dialog/confirm-dialog.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { MaximizeDialogButtonModule } from '@portal-core/general/components/maximize-dialog-button/maximize-dialog-button.module';
import { PreventDefaultModule } from '@portal-core/general/directives/prevent-default/prevent-default.module';
import { DurationModule } from '@portal-core/general/pipes/duration/duration.module';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { LogTabPanelModule } from '@portal-core/live-log/components/log-tab-panel/log-tab-panel.module';
import { PublicationAvatarModule } from '@portal-core/publications/components/publication-avatar/publication-avatar.module';
import { PublicationDeletionFormModule } from '@portal-core/publications/components/publication-deletion-form/publication-deletion-form.module';
import { PublicationOverviewModule } from '@portal-core/publications/components/publication-overview/publication-overview.module';
import { PublicationProfileDialogComponent } from '@portal-core/publications/components/publication-profile-dialog/publication-profile-dialog.component';
import { TargetAvatarModule } from '@portal-core/targets/components/target-avatar/target-avatar.module';
import { SwitchBoardModule } from '@portal-core/ui/switch-board/switch-board.module';

@NgModule({
  declarations: [
    PublicationProfileDialogComponent
  ],
  imports: [
    PublicationAvatarModule,
    BuildAvatarModule,
    CommonModule,
    ConfirmDialogModule,
    DurationModule,
    ErrorsExpansionPanelModule,
    PublicationOverviewModule,
    LoaderModule,
    LogTabPanelModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatListModule,
    MatSnackBarModule,
    MatTabsModule,
    MatTooltipModule,
    MaximizeDialogButtonModule,
    PreventDefaultModule,
    ProjectAvatarModule,
    RouterModule,
    SwitchBoardModule,
    TargetAvatarModule,
    BranchAvatarModule,
    PublicationDeletionFormModule,
    DestinationAvatarModule
  ],
  exports: [
    PublicationProfileDialogComponent
  ]
})
export class PublicationProfileDialogModule { }
